import React from "react";
import { createPortal } from "react-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getSampleColor, getSampleLabel } from "../utils/sampleHelpers";

export default function DragGhost({ ghostPos, ghostShift, dynamicLeaves }) {
  if (!ghostPos || !ghostShift) return null;

  return createPortal(
    <Box
      sx={{
        position: "fixed",
        left: ghostPos.x - 30,
        top: ghostPos.y - 40,
        zIndex: 9999,
        pointerEvents: "none",
        borderRadius: "8px",
        px: 1,
        py: 0.5,
        backgroundColor: getSampleColor(ghostShift),
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        transform: "scale(1.08)",
        minWidth: 52,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0.92,
      }}
    >
      <Typography
        noWrap
        sx={{
          fontSize: "0.7rem",
          fontWeight: 700,
          color: "#fff",
          textShadow: "0 1px 2px rgba(0,0,0,0.4)",
        }}
      >
        {getSampleLabel(ghostShift, dynamicLeaves)}
      </Typography>
    </Box>,
    document.body
  );
}
